import { registerJSONResolver } from '../../registry/jsonResolvers';
import { registerDiagram, createDiagramFromJSON } from '../../diagram/registryCore';
import { Diagram } from '../../diagram/index';
import '../../diagram/definitions';
export var diagramPlugin = {
    name: 'lightdraw-diagram',
    version: '1.2.1',
    install: function (LD) {
        registerJSONResolver(function (type, props, app) { return createDiagramFromJSON(type, props, app); });
        LD.registerDiagram =
            registerDiagram;
        LD.Diagram = Diagram;
    },
};
export { Diagram };
export { registerDiagram, createDiagramFromJSON, diagramToJSON, forceDirectedLayout, routeConnector, } from '../../diagram/registry';
export { DIAGRAM, resolveDiagramTheme, getActiveDiagram, getDiagramTheme, syncActiveDiagramTheme, runWithDiagramTheme, } from '../../diagram/theme';
export { refreshDiagram, installDiagramRebuild } from '../../diagram/refresh';
export default diagramPlugin;
